module.exports = fs;


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 201
// module chunks = 4